// Einheitliche, skalierbare Parkett-Star-Gold-Grafik mit Jahresaufdruck.
// Bewusst als Vektor nachgebaut, damit alle Sterne identisch aussehen und
// das Jahr sauber und konsistent dargestellt wird.
const POINTS = "50,2 61.8,35.4 98,35.8 68.8,57.6 79.4,92 50,70.8 20.6,92 31.2,57.6 2,35.8 38.2,35.4";

export const ParkettStar = ({ year, size = 132 }) => {
  const gid = `pstar-${year}`;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" width={size} height={size} className="drop-shadow-[0_6px_14px_rgba(0,0,0,0.35)]">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0.25" y2="1">
            <stop offset="0%" stopColor="#FCEBA8" />
            <stop offset="42%" stopColor="#EEC150" />
            <stop offset="100%" stopColor="#CF931A" />
          </linearGradient>
        </defs>
        <polygon points={POINTS} fill={`url(#${gid})`} />
        {/* dezentes Glanzlicht */}
        <ellipse cx="42" cy="32" rx="9" ry="5" fill="#FFFFFF" opacity="0.55" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center" style={{ paddingTop: size * 0.08 }}>
        <span
          className="font-display font-bold text-[#3A2A06]"
          style={{ fontSize: size * 0.19, letterSpacing: "0.01em" }}
        >
          {year}
        </span>
      </div>
    </div>
  );
};
